<template>
  <div class="sm:col-span-6">
    <span class="relative z-0 shadow-sm rounded-md grid grid-cols-2 sm:grid-cols-6">
      <button type="button"
              @click="setGender('m')"
              id="gender-m"
              :class="genderClass('m')"
              >
          Herr
      </button>
      <button type="button"
              @click="setGender('f')"
              id="gender-f"
              :class="genderClass('f')"
              >
          Frau
      </button>
    </span>
    <p v-if="errors['start_gender']" class="mt-2 text-sm text-red-600 error-message">{{ errors['start_gender'] }}</p>
    <input type="hidden"
           id="start_gender"
           name="start_gender"
           :value="gender"
           aria-invalid="false"
    />
  </div>
</template>

<script setup>
import {ref, computed} from "vue";
import {useTenantStore} from "../stores/tenant";

const tenant = useTenantStore();
const gender = ref(tenant.formValues.start_gender || '');
const errors = computed(() => tenant.errors);

const setGender = (type) => {
  gender.value = type;
  tenant.setFormValue('start_gender', type);
  tenant.validateField('start_gender', type);
};

const genderClass = (type) => {
  return [
    'mb-6 sm:mb-0 relative items-center px-4 py-2 rounded-l-md rounded-r-md border border-gray-400 text-sm font-medium text-gray-700 hover:border-blue-700 col-span-3',
    { 'bg-green-300': tenant.formValues.start_gender === type },
    type === 'm' ? 'sm:rounded-r-none' : 'sm:rounded-l-none -ml-px',
  ];
};


</script>
